import ls from 'localstorage-slim';

const STORAGE_KEY = 'utm_data';
const STORAGE_TTL_SECONDS = 60 * 60 * 24 * 1; // 1 day

export const UTM_QUERY_STRING_KEY_CAMPAIGN = 'utm_campaign';

export type UtmStorage = Record<string, string>;

export class UtmService {
  static getFromStorage = () => {
    return ls.get<UtmStorage>(STORAGE_KEY);
  };

  static setToStorage = (payload: UtmStorage) => {
    if (!payload || Object.keys(payload).length === 0) {
      return;
    }

    ls.set<UtmStorage>(STORAGE_KEY, payload, {
      ttl: STORAGE_TTL_SECONDS,
    });
  };

  static removeFromStorage = () => {
    ls.remove(STORAGE_KEY);
  };
}
